import {Mapper} from '@s-ui/domain'

export class FromPlaceholderUrlToNextPageUrl extends Mapper {
  map = ({currentPage, placeholder, totalPages, url = ''}) => {
    const nextPage = currentPage + 1
    if (nextPage > totalPages) return
    return url.replace(placeholder, nextPage)
  }
}
